import { Map } from 'immutable'
import _get from 'lodash/get'
import {
  SET_SUBSCRIPTION_CANCELS_IN_BATCH_DATA,
  SET_SUBSCRIPTION_CANCELS_IN_BATCH_ERROR,
  SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROCESSING,
  SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROGRESS,
  SET_USER_HANDLE_CHARGEBACKS_DATA,
  SET_USER_HANDLE_CHARGEBACKS_ERROR,
  SET_USER_HANDLE_CHARGEBACKS_PROCESSING,
  SET_USER_HANDLE_CHARGEBACKS_PROGRESS,
  SET_TURN_ON_AUTO_PAY_IN_BATCH_DATA,
  SET_TURN_ON_AUTO_PAY_IN_BATCH_ERROR,
  SET_TURN_ON_AUTO_PAY_IN_BATCH_PROCESSING,
  SET_TURN_ON_AUTO_PAY_IN_BATCH_PROGRESS,
  SET_USER_HANDLE_INVOICES_POST_ERROR,
  SET_USER_HANDLE_INVOICES_POST_DATA,
  SET_USER_HANDLE_INVOICES_POST_PROCESSING,
  SET_USER_HANDLE_INVOICES_POST_PROGRESS,
} from './actions'

export const initialState = Map()

export default (state = initialState, action) => {
  const { payload, type } = action
  switch (type) {
    case SET_USER_HANDLE_CHARGEBACKS_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_HANDLE_CHARGEBACKS_PROGRESS:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        progress: payload.progress,
        processing: payload.processing,
      })))
    case SET_USER_HANDLE_CHARGEBACKS_DATA:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
      })))
    case SET_USER_HANDLE_CHARGEBACKS_ERROR:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: false,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
        error: payload.error,
      })))
    case SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_SUBSCRIPTION_CANCELS_IN_BATCH_PROGRESS:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        progress: payload.progress,
        processing: payload.processing,
      })))
    case SET_SUBSCRIPTION_CANCELS_IN_BATCH_DATA:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
      })))
    case SET_SUBSCRIPTION_CANCELS_IN_BATCH_ERROR:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: false,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
        error: payload.error,
      })))
    case SET_TURN_ON_AUTO_PAY_IN_BATCH_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_TURN_ON_AUTO_PAY_IN_BATCH_PROGRESS:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        progress: payload.progress,
        processing: payload.processing,
      })))
    case SET_TURN_ON_AUTO_PAY_IN_BATCH_DATA:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
      })))
    case SET_TURN_ON_AUTO_PAY_IN_BATCH_ERROR:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: false,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
        error: payload.error,
      })))
    case SET_USER_HANDLE_INVOICES_POST_PROCESSING:
      return state.setIn([payload.storeKey, 'processing'], payload.processing)
    case SET_USER_HANDLE_INVOICES_POST_PROGRESS:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        progress: payload.progress,
        processing: payload.processing,
      })))
    case SET_USER_HANDLE_INVOICES_POST_DATA:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: true,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
      })))
    case SET_USER_HANDLE_INVOICES_POST_ERROR:
      return state.update(payload.storeKey, (value) => value.merge(Map({
        success: false,
        data: _get(payload, 'data', Map()),
        processing: payload.processing,
        error: payload.error,
      })))
    default:
      return state
  }
}
